var _desc, _defs, _g, _path, _g2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 55.058411,
    viewBox: "0 0 48 55.0584",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\r\n\t\t\tCreated with Pixso.\r\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter_1_5413_dd",
    x: 15.882812,
    y: 38.117188,
    width: 16.941162,
    height: 16.941223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.35294
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.27059 0 0 0 0 0.22745 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect_dropShadow_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect_dropShadow_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter_1_5416_dd",
    x: 0,
    y: 0,
    width: 48,
    height: 49.411804,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.35294
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.27059 0 0 0 0 0.22745 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect_dropShadow_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect_dropShadow_1",
    result: "shape"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter_1_5413_dd)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.76 46.58C25.76 47.36 25.13 47.99 24.35 47.99C23.57 47.99 22.94 47.36 22.94 46.58C22.94 45.8 23.57 45.17 24.35 45.17C25.13 45.17 25.76 45.8 25.76 46.58Z",
    fill: "#000000",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.76 46.58C25.76 47.36 25.13 47.99 24.35 47.99C23.57 47.99 22.94 47.36 22.94 46.58C22.94 45.8 23.57 45.17 24.35 45.17C25.13 45.17 25.76 45.8 25.76 46.58Z",
    fill: "#FF453A",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter_1_5416_dd)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.23 39.34C25.02 40.03 24.4 42.27 24.4 42.27C24.4 42.27 24.09 42.49 23.99 42.19C23.46 40.47 22.27 39.39 22.27 39.39C13.72 38.57 7.05 31.66 7.05 23.26C7.05 14.31 14.64 7.05 23.99 7.05C33.35 7.05 40.94 14.31 40.94 23.26C40.94 31.5 34.53 38.29 26.23 39.34Z",
    fill: "#000000",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.23 39.34C25.02 40.03 24.4 42.27 24.4 42.27C24.4 42.27 24.09 42.49 23.99 42.19C23.46 40.47 22.27 39.39 22.27 39.39C13.72 38.57 7.05 31.66 7.05 23.26C7.05 14.31 14.64 7.05 23.99 7.05C33.35 7.05 40.94 14.31 40.94 23.26C40.94 31.5 34.53 38.29 26.23 39.34Z",
    fill: "#FF453A",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMark);
export default __webpack_public_path__ + "static/media/mapMark.46eaa3e4b86c8f2905eda7a6b9c709ff.svg";
export { ForwardRef as ReactComponent };